export default "__VITE_ASSET__C6rNe$7f__"